// Mandantenspezifische Module – Schulungen, die nur fuer einen einzelnen Kunden
// produziert wurden und inhaltlich fuer niemanden sonst Sinn ergeben.
//
// Technisch sind sie ganz normale Plattformmodule: sie stehen im Code, sind aber
// wie alle anderen lizenzpflichtig und damit fuer jeden Mandanten unsichtbar,
// solange ihre ID nicht in features.licensed_modules steht (GA-Portal). Der
// Unterschied ist nur die Gruppierung im GA-Portal – dort stehen sie unter dem
// Namen des Mandanten, damit niemand sie versehentlich woanders freischaltet.
//
// Lernbloecke und Quizpool liegen in eigenen Dateien (eigener Chunk), damit ein
// Mandant nicht die Inhalte aller anderen mitlaedt: cpTechStrategyContent.ts,
// cpTechInfosecContent.ts.

import type { SecurityModuleMeta } from "./securityModules";

/** Mandant, fuer den ein Modul produziert wurde – Gruppenname im GA-Portal. */
export const TENANT_MODULE_OWNER: Record<string, string> = {
  "cpt-01-strategie-2030": "CP Tech",
  "cpt-02-informationssicherheit": "CP Tech",
};

export const TENANT_MODULES: SecurityModuleMeta[] = [
  {
    id: "cpt-01-strategie-2030",
    topicId: "cpt-01-strategie-2030",
    title: "CP Tech Strategie 2030",
    shortTitle: "Strategie 2030",
    description: "Wohin CP Tech bis 2030 will, welche Initiativen dorthin führen und wer sie verantwortet – und was das für die eigene Arbeit bedeutet.",
    duration: "25 Min.",
    color: "#0E8FA0",
    icon: "🧭",
    focusAreas: [
      "Strategie statt Maßnahmenliste",
      "Vision 2030 und Zielbild",
      "Kerninitiativen und Befähiger",
      "Verantwortliche Experten und Strategiepaten",
      "MOALs, OKRs und KPIs",
      "Der eigene Beitrag im Arbeitsalltag",
    ],
    scenario: "Zwei Aufgaben liegen auf dem Tisch und beide sind dringend. Die eine zahlt auf eine strategische Initiative ein, die andere ist Tagesgeschäft, das niemand vermissen würde.",
    level: "basis",
  },
  {
    id: "cpt-02-informationssicherheit",
    topicId: "cpt-02-informationssicherheit",
    title: "CP Tech Informationssicherheit",
    shortTitle: "Informationssicherheit",
    description: "Die Pflichtunterweisung zur Informationssicherheit bei CP Tech: Schutzbedarf erkennen, sicher arbeiten und weitergeben, das Arbeitsumfeld schützen – und wissen, was bei geheimen Projekten zusätzlich gilt.",
    duration: "20 Min.",
    color: "#1B6AB1",
    icon: "🔐",
    focusAreas: [
      "Vier Sicherheitsstufen und personenbezogene Daten",
      "Sicher arbeiten: Geräte, Zugänge, MFA und Netze",
      "Weitergabe: erlaubter Empfänger, vorgeschriebener Weg",
      "Arbeitsumfeld: Zutritt, Fotografierverbot, Clean Desk",
      "Zusätzliche Anforderungen bei geheimen Projekten",
      "Melden bei Unsicherheit oder Verdacht",
    ],
    scenario: "Du bekommst eine als vertraulich gekennzeichnete Projektzeichnung. Ein Kunde fragt danach, unterwegs willst du weiterarbeiten – und am Feierabend liegt der Ausdruck noch auf dem Schreibtisch.",
    level: "basis",
  },
];

export const TENANT_MODULE_IDS: ReadonlySet<string> = new Set(TENANT_MODULES.map(m => m.id));

export function isTenantModule(moduleId: string): boolean {
  return TENANT_MODULE_IDS.has(moduleId);
}
